import React, { useState } from 'react';
import { Box, Typography, Button, TextField, Paper } from '@material-ui/core';
import { useDataProvider, useTranslate } from 'react-admin';
import colors from '../CustomizedUIs/Colors';
import { makeStyles } from "@material-ui/core/styles";
import CustomPoper from '../CustomizedUIs/CustomPoperWhite';
import TextButton from '../CustomizedUIs/TextButton';
// import TextField from '../CustomizedUIs/CustomTextFiled'
const itemStyles = makeStyles(theme => ({
    underlineNotValue: {
        '&::before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        },
        '&:hover:not($disabled):before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        }
    },
    focuses: {
        backgroundColor: '#f3f7fa !important'
    },
    boxBoder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: '#f3f7fa',
        borderRightColor: '#f3f7fa',
    },
    textError: {
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.36,
        letterSpacing: 'normal',

    },
    textLabel: {
        marginBottom: 8,
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '0.13px',
        color: '#88898c',
    },
    textLableError: {
        marginBottom: 8,
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '0.13px',
    },
    input: {
        backgroundColor: '#f3f7fa',
        borderRadius: '2px',
        "&:hover": {
            backgroundColor: '#f3f7fa'
        },
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.85,
        letterSpacing: '0.13px',
        color: '#88898c',
    },
    title: {
        fontFamily: "UniviaPro-Medium",
        fontSize: "14px",
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 2.14,
        letterSpacing: " 0.15px",
        padding: 10,
    },
    btnCreate: {
        fontFamily: "UniviaPro",
        fontSize: "11px",
        fontWeight: 'bold',
        fontStretch: "normal",
        fontStyle: 'normal',
        lineHeight: "normal",
        letterSpacing: " 0.44px",
        color: "#ffffff",
        padding: '13px 30px 13px 30px'

    }
}));
function CreateFolderPopup({ onCreateFolderSuccess, close, parentId }) {
    const dataProvider = useDataProvider();
    const translate = useTranslate();
    const classes = itemStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [openPoper, setOpenPopper] = React.useState(false);
    // const [name, setName] = useState('');
    const [isCreating, setIsCreating] = useState(false);
    const [textValue, setTextValue] = React.useState({
        name: '',
    });
    const [validate, setValidate] = React.useState({
        name: {
            isError: true,
            message: ''
        },
    });
    const onSubmit = (e) => {
        e.preventDefault();
        setIsCreating(true);
        dataProvider('CREATE', 'category', {
            data: {
                name: textValue.name,
                parentId
            }
        }).then(({ data }) => {
            onCreateFolderSuccess('pos.categories.createFolder.success', textValue.name);
        }).catch(error => {
            onCreateFolderSuccess(error.message);
            // setError(translate(error.message));
        }).finally(() => setIsCreating(false));
    }
    const textOnChange = prop => (e) => {
        setTextValue({
            ...textValue, [prop]: e.target.value
        })
        validateFc(prop, e.target.value)
    }

    const handleClosePoper = () => {
        setOpenPopper(false);
    };
    const handleClickOpenPoper = (event) => {
        setAnchorEl(event.currentTarget);
        setOpenPopper(true);
    };

    const validateFc = (prop, value) => {
        if (prop === 'name') {
            if (value.length === 0)

                setValidate({
                    ...validate, [prop]: value.length === 0 ? {
                        isError: true, message: translate(`pos.user.required`)
                    } : {
                            isError: false, message: ''
                        }
                })
            else {
                const test = (/[*|\\:\/<>?"]/).test(value)
                setValidate({
                    ...validate, [prop]: test === true ? {
                        isError: true, message: translate(`pos.categories.errorFileName`)
                    } : {
                            isError: false, message: ''
                        }
                })
            }
        }
        else
            setValidate({
                ...validate, [prop]: value.length === 0 ? {
                    isError: true, message: translate(`pos.user.required`)
                } : {
                        isError: false, message: ''
                    }
            })

    }

    return (
        <Paper onSubmit={onSubmit} component='form'>
            <Box p={2} width={360}>
                <Typography className={classes.title}>{translate('pos.categories.createFolder.name')}</Typography>
                <TextField
                    required
                    label={translate('pos.categories.createFolder.placeholder')}
                    onBlur={() => {
                        validateFc('name', textValue.name)
                    }}
                    value={textValue.name}
                    error={validate.name.message != "" && validate.name.isError}
                    helperText={validate.name.message}
                    fullWidth
                    onChange={textOnChange('name')}
                    variant="filled"
                    FormHelperTextProps={{
                        className: classes.textError
                    }}
                    InputLabelProps={{
                        // className: classes.textLabel,
                        classes: {
                            root: classes.textLabel,
                            error: classes.textLableError
                        }
                    }}
                    InputProps={{
                        endAdornment:
                            <CustomPoper
                                open={openPoper}
                                anchorEl={anchorEl}
                                handleClick={handleClickOpenPoper}
                                handleClose={handleClosePoper}
                                title={translate(`pos.categories.folderNameTitle`)}
                                content={translate(`pos.categories.folderName`)}
                                icon={<b>?</b>}
                            />,
                        className: classes.input,
                        classes: {
                            underline: textValue.name !== '' ? classes.underline : classes.underlineNotValue,
                            focused: classes.focuses
                        }
                    }}
                />
                <Box style={{ paddingTop: 10 }} mt={1} display='flex' justifyContent='flex-end'>
                    <TextButton size='large' color='primary' type='button' style={{ marginRight: '1rem' }} onClick={close} />
                    <Button disabled={(validate.name.message != "" && validate.name.isError) || isCreating} variant='contained' className={classes.btnCreate} color='primary' type='submit'>{translate('pos.common.create')}</Button>
                </Box>
            </Box>
        </Paper>
    );
}

export default CreateFolderPopup;
